import Vue from "vue"
import Vuex from "vuex"
import { selectByWebUrl } from "@@/api/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    platformInfo: {}
  },
  mutations:{
    SET_PALATFORM_IFFO(state, platformInfo) {
      state.platformInfo = platformInfo
      console.log('platformInfo', platformInfo)
    }
  },
  actions:{
    getPlatformInfo({ commit }){

      let webUrl = window.location.href.split('/')
      webUrl.splice(-1,1)

      selectByWebUrl({webUrl: `${webUrl.join('/')}/` }).then(res => {
        const { data: { items } } = res
        if (items && items.length ) {
          commit('SET_PALATFORM_IFFO', items[0] || {})
        }
      })
    }
  }
})
